import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDown, Sparkles, Compass, Wind } from "lucide-react";
import { useTranslation } from "react-i18next";
import EditorialHeader from "../compponents/EditorialHeader";
import EditorialFooter from "../compponents/EditorialFooter";
import useScrollReveal from "../hooks/useScrollReveal";
import TobiasImage from "../images/optimized/tobiasimage.jpg";
import "./About.css";
import "./HomePage.css";

export default function HomePage() {
  const { t } = useTranslation();
  const page = useScrollReveal();
  const copy = (key) => t(`home.design.${key}`);

  return (
    <div className="about-page home-page" ref={page}>
      <a className="about-skip" href="#home-main">{t("about.design.skip")}</a>
      <EditorialHeader />
      <main id="home-main">
        <section className="home-hero about-wrap" aria-labelledby="home-title">
          <div className="about-hero-copy">
            <p className="about-eyebrow"><span />{copy("eyebrow")}</p>
            <h1 id="home-title">{copy("title")} <em>{copy("titleAccent")}</em></h1>
            <p className="about-body">{copy("lead")}</p>
            <div className="home-actions"><Link className="about-button" to="/services">{t("home.buttons.exploreServices")}<ArrowUpRight size={20} aria-hidden="true" /></Link><Link className="about-text-link" to="/about">{copy("meet")}<ArrowUpRight size={18} aria-hidden="true" /></Link></div>
            <a className="about-scroll" href="#home-intro"><span><ArrowDown size={16} aria-hidden="true" /></span>{copy("scroll")}</a>
          </div>
          <div className="home-hero-art">
            <div className="home-hero-outline" aria-hidden="true" />
            <img src={`${process.env.PUBLIC_URL}/images/home-hero.jpg`} alt={copy("heroAlt")} width={1200} height={686} loading="eager" fetchpriority="high" />
            <div className="home-art-caption"><Sparkles size={22} strokeWidth={1} aria-hidden="true" /><span>{copy("imageNote")}</span></div>
            <p className="home-image-credit">{copy("imageCaption")}</p>
          </div>
        </section>

        <div className="home-values about-wrap" aria-label={copy("valuesLabel")}>
          {[ [Wind, "value1"], [Compass, "value2"], [Sparkles, "value3"] ].map(([Icon, key]) => <div key={key}><Icon size={19} strokeWidth={1.2} aria-hidden="true" /><span>{copy(key)}</span></div>)}
        </div>

        <section className="home-intro about-wrap" id="home-intro" aria-labelledby="home-intro-title" data-reveal>
          <figure className="home-nature"><img src={TobiasImage} alt={copy("natureAlt")} width={1000} height={1500} loading="lazy" decoding="async" /><figcaption>{copy("natureCaption")}</figcaption></figure>
          <div><p className="about-eyebrow">01 / {copy("introLabel")}</p><h2 id="home-intro-title">{copy("introTitle")}</h2><p className="about-body">{copy("introText")}</p><p className="home-intro-note">{copy("introNote")}</p><Link className="about-text-link" to="/about">{copy("approachLink")}<ArrowUpRight size={18} aria-hidden="true" /></Link></div>
        </section>

        <section className="home-pause" aria-labelledby="home-pause-title" data-reveal>
          <div className="about-wrap"><div className="home-pause-heading"><p className="about-eyebrow">02 / {copy("pauseLabel")}</p><h2 id="home-pause-title">{copy("pauseTitle")}</h2><p>{copy("pauseText")}</p></div>
            <div className="home-feelings">{["stress", "direction", "patterns", "connection"].map((key, index) => <div key={key}><span>0{index + 1}</span><h3>{copy(`${key}Title`)}</h3><p>{copy(`${key}Text`)}</p></div>)}</div>
          </div>
        </section>

        <section className="home-paths about-wrap" aria-labelledby="home-paths-title" data-reveal>
          <div className="about-section-heading"><p className="about-eyebrow">03 / {copy("pathsLabel")}</p><h2 id="home-paths-title">{copy("pathsTitle")}</h2></div>
          <div className="about-practices">{[["energy", Sparkles], ["potential", Compass]].map(([key, Icon], index) => <article className="about-practice" key={key}><div className="about-practice-top"><Icon size={30} strokeWidth={1.2} aria-hidden="true" /><span>0{index + 1}</span></div><h3>{t(`about.design.${key}Title`)}</h3><p>{t(`about.design.${key}Description`)}</p><Link className="about-text-link" to="/services">{copy("sessionsLink")}<ArrowUpRight size={18} aria-hidden="true" /></Link></article>)}</div>
        </section>

        <section className="home-guide about-wrap" aria-labelledby="home-guide-title" data-reveal>
          <div className="home-guide-photo"><img src={`${process.env.PUBLIC_URL}/valeria_photo.png`} alt={t("about.design.portraitAlt")} width={1145} height={1374} loading="lazy" decoding="async" /></div>
          <div><p className="about-eyebrow">{copy("guideLabel")}</p><h2 id="home-guide-title">{t("about.introTitle")}.</h2><p className="about-body">{copy("guideText")}</p><Link className="about-text-link" to="/about">{copy("guideLink")}<ArrowUpRight size={18} aria-hidden="true" /></Link></div>
          <span className="home-guide-mark" aria-hidden="true">L</span>
        </section>

        <section className="about-connect about-wrap" aria-labelledby="home-connect-title" data-reveal><div><p className="about-eyebrow">{t("about.design.nextStep")}</p><h2 id="home-connect-title">{t("about.design.connectTitle")}</h2><p>{t("about.design.connectDescription")}</p></div><Link className="about-button" to="/contact">{t("about.introButton")}<ArrowUpRight size={20} aria-hidden="true" /></Link></section>
      </main>
      <EditorialFooter />
    </div>
  );
}
